import React from "react";
import { useNavigate } from "react-router-dom";
import "./App.css";
import termsContent from "./legal/termsOfServiceContent.json";

const pStyle = { color: "#334155", marginBottom: 24, lineHeight: 1.6 };
const h2Style = { color: "#2563eb", marginTop: 32, marginBottom: 16, fontSize: "1.4em" };
const linkStyle = { color: "#2563eb", textDecoration: "underline" };

function TermsParagraph({ paragraph }) {
  if (typeof paragraph === "string") {
    return <p style={pStyle}>{paragraph}</p>;
  }
  if (paragraph && Array.isArray(paragraph.segments)) {
    return (
      <p style={pStyle}>
        {paragraph.segments.map((seg, i) =>
          typeof seg === "string" ? (
            <React.Fragment key={i}>{seg}</React.Fragment>
          ) : (
            <a key={i} href={`mailto:${seg.mailto}`} style={linkStyle}>
              {seg.mailto}
            </a>
          )
        )}
      </p>
    );
  }
  return null;
}

export default function Terms({ onBack }) {
  const navigate = useNavigate();
  return (
    <div className="ffb-bg">
      <header className="ffb-header">
        <h1 className="ffb-header-title">🏈 Terms of Service 🏈</h1>
      </header>
      <div style={{ padding: 32, minHeight: 600, maxWidth: 800, margin: "0 auto" }}>
        <button
          onClick={onBack}
          className="ffb-btn"
          style={{ marginBottom: 24, padding: "8px 20px", fontSize: 16, borderRadius: 4 }}
        >
          Back to Home
        </button>

        <div style={{ background: "#fff", borderRadius: 12, boxShadow: "0 2px 12px rgba(30,58,92,0.07)", padding: 32 }}>
          <h1 style={{ color: "#1e3a8a", marginTop: 0, marginBottom: 24, fontSize: "2em" }}>
            {termsContent.mainHeading}
          </h1>

          <p style={{ color: "#64748b", marginBottom: 32, fontSize: "1.1em" }}>
            <strong>Last updated: {termsContent.lastUpdated}</strong>
          </p>

          {termsContent.sections.map((section) => (
            <React.Fragment key={section.heading}>
              <h2 id={section.anchorId || undefined} style={h2Style}>{section.heading}</h2>
              {section.paragraphs.map((para, idx) => (
                <TermsParagraph key={idx} paragraph={para} />
              ))}
            </React.Fragment>
          ))}

          <p style={{ color: "#334155", marginTop: 32, lineHeight: 1.6 }}>
            <button
              onClick={() => navigate("/privacy")}
              style={{
                background: "none",
                border: "none",
                color: "#2563eb",
                textDecoration: "underline",
                cursor: "pointer",
                padding: 0,
                font: "inherit",
              }}
            >
              {termsContent.privacyPolicyLinkText}
            </button>
          </p>
        </div>
      </div>

      <footer
        style={{
          textAlign: "center",
          color: "#94a3b8",
          fontSize: "0.98em",
          marginTop: 40,
          padding: 20,
        }}
      />
    </div>
  );
}
